/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes, { element } from 'prop-types';
import XtadiumRoomPosterXXLNoImage from '../../atoms/customIcons/XtadiumRoomPosterXXLNoImage.jpg';
import XtadiumRoomPosterXLVNoImage from '../../atoms/customIcons/XtadiumRoomPosterXLVNoImage.png';
import XtadiumRoomPosterXLHNoImage from '../../atoms/customIcons/XtadiumRoomPosterXLHNoImage.png';
import XtadiumRoomPosterLVNoImage from '../../atoms/customIcons/XtadiumRoomPosterLVNoImage.png';
import XtadiumRoomPosterLHNoImage from '../../atoms/customIcons/XtadiumRoomPosterLHNoImage.png';
import XtadiumRoomPosterMNoImage from '../../atoms/customIcons/XtadiumRoomPosterMNoImage.png';
import XtadiumRoomPosterXSNoImage from '../../atoms/customIcons/XtadiumRoomPosterXSNoImage.png';
import XtadiumRoomPosterSVNoImage from '../../atoms/customIcons/XtadiumRoomPosterSVNoImage.png';
import XtadiumRoomPosterSHNoImage from '../../atoms/customIcons/XtadiumRoomPosterSHNoImage.png';


import XtadiumContentPosterXXLNoImage from '../../atoms/customIcons/XtadiumContentPosterXXLNoImage.png';
import XtadiumContentPosterXLVNoImage from '../../atoms/customIcons/XtadiumContentPosterXLVNoImage.png';
import XtadiumContentPosterXLHNoImage from '../../atoms/customIcons/XtadiumContentPosterXLHNoImage.png';
import XtadiumContentPosterLVNoImage from '../../atoms/customIcons/XtadiumContentPosterLVNoImage.png';
import XtadiumContentPosterLHNoImage from '../../atoms/customIcons/XtadiumContentPosterLHNoImage.png';
import XtadiumContentPosterMNoImage from '../../atoms/customIcons/XtadiumContentPosterMNoImage.png';
import XtadiumContentPosterFWoImage from '../../atoms/customIcons/XtadiumContentPosterMNoImage.png';


import { TabContent } from 'react-bootstrap';
import { isBuffer } from 'lodash';
import SingleTagPreview from './singleTagPreview';
import { TagsCheckToday, TagsReplaceDateLabelsWithDate } from '../../../utils/dateUtils';

/**
 * Form Input Text is a basic HTML input field, label, error text and HelpButton.
 * It is designed to send the input value to a parent component, such as organisms Form,
 * and to shows the validation state of the field provided by the parent component.
 */
const PosterPreview = (props) => {
  const {
    size,
    visible,
    tags,
    images,
    name,
    purchase,
    subscription,
    georestricted,
    tagMode
    
  } = props;
  const [topTags,setTopTags]=useState([]);
  const [bottomTags,setBottomTags]=useState([]);
  const [middleTags,setMiddleTags]=useState([]);
  const [displayImage,setDisplayImage] =useState(null);
  const [XtadiumPosterNoImage,setXtadiumPosterNoImage]=useState(null);
  const [width,setWidth]=useState(0);
  const [height,setHeight]=useState(0);
  const [scaleImages,setScaleImages]=useState(0.6);
  const [bottomLeftTags,setBottomLeftTags]=useState([]);
  useEffect(() => {
    setDisplayImage(null);
    let resTopTags=[];
    setTopTags([]);
    let resBottomTags=[];
    let resMiddleTags=[];
    let resBottomLeftTags=[];
    if(tags){
      let topWidth=100;
      if(tags.tags){
        tags.tags.forEach((tag,index)=>{
          if(tag.visible==1){
            if(tag.props.position=="top"){
                if(topWidth-tag.props.minWidth>0){
                  if(tag.label && (tag.label.includes("#date") || tag.label.includes("#time"))){
                    if(tag.name=="Live-today" && TagsCheckToday(tag.label)==true){
                      tag.label=TagsReplaceDateLabelsWithDate(tag.label);
                      let t=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
                      resTopTags.push(t);
                    }else if(tag.name=="Live-date" && !TagsCheckToday(tag.label)){
                      tag.label=TagsReplaceDateLabelsWithDate(tag.label);
                      let t=(<SingleTagPreview key={tag.id} mode="extendedInfo" rawValue={tag} />);
                      resTopTags.push(t);
                    }
                  }else{  
                    let t=(<SingleTagPreview key={tag.id} mode="poster" rawValue={tag} />);
                    resTopTags=[...resTopTags,t];
                    topWidth=topWidth-tag.props.minWidth;
                  }
                }
            }
            if(tag.props.position=="bottom")  {
              let b=(<SingleTagPreview key={tag.id} mode="poster" rawValue={tag} />);
              resBottomTags=[...resBottomTags,b];
            }
            if(tag.props.position=="middle"){
              let m=(<SingleTagPreview key={tag.id} mode="poster" rawValue={tag} />);
              resMiddleTags=[...resMiddleTags,m];
            }
          }
        });
      }
      if(tags.defaultTags){
        let found = tags.defaultTags.find((element) => element.props && element.props.position === "bottom-left");
        if (found && found.visible) {
          let b = (
            <SingleTagPreview
              key={found.id}
              mode="poster"
              rawValue={found}
            />
          );

          resBottomLeftTags = [...resBottomLeftTags, b];
        }
        if (purchase=="yes"){
          let found = tags.defaultTags.find((element=>element.name=="Purchase-on"));
          let t;
          if(found && found.visible && found.posterVisible){
            t=(<SingleTagPreview key={found.id} mode="poster" rawValue={found} />);
          }
          resTopTags=[...resTopTags,t];
        }
        if(purchase=="no"){
          let found = tags.defaultTags.find((element=>element.name=="Purchase-off"));
          let t;
          if(found && found.visible){
            t=(<SingleTagPreview key={found.id} mode="poster" rawValue={found} />);
          }
          resTopTags=[...resTopTags,t];
        }
        if(subscription=="yes"){
          let found = tags.defaultTags.find((element=>element.name=="Subscription-on"));
          let t;
          if(found && found.visible){
            t=(<SingleTagPreview key={found.id} mode="poster" rawValue={found} />);
          }
          resTopTags=[...resTopTags,t];
        }
        if(subscription=="no"){
          let found = tags.defaultTags.find((element=>element.name=="Subscription-off"));
          if(found && found.visible){
            let t=(<SingleTagPreview key={found.id} mode="poster" rawValue={found} />);
            resTopTags=[...resTopTags,t];
          }
        }
        if(georestricted=="yes"){
          let found = tags.defaultTags.find((element=>element.name=="Geo-restricted"));
          if(found && found.visible){
            let t=(<SingleTagPreview key={found.id} mode="poster" rawValue={found} />);
            resTopTags=[t];
          }
        }
      }
      setTopTags(resTopTags);
      setBottomTags(resBottomTags);
      setMiddleTags(resMiddleTags);
      setBottomLeftTags(resBottomLeftTags);
      switch(size){
        case "xxl":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterXXLNoImage);
            setWidth(664*scaleImages +"px");
            setHeight(664*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterXXLNoImage);
            setWidth(664*scaleImages +"px");
            setHeight(575*scaleImages +"px");
          }
        break;
        case "xlv":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterXLVNoImage);
            setWidth(318*scaleImages +"px");
            setHeight(664*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterXLVNoImage);
            setWidth(318*scaleImages +"px");
            setHeight(575*scaleImages +"px");
          }
        break;
        case "xlh":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterXLHNoImage);  
            setWidth(664*scaleImages +"px");
            setHeight(318*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterXLHNoImage);  
            setWidth(664*scaleImages +"px");
            setHeight(227*scaleImages +"px");
          }
        break; 
        case "lv":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterLVNoImage);
            setWidth(318*scaleImages +"px");
            setHeight(492*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterLVNoImage);  
            setWidth(318*scaleImages +"px");
            setHeight(402*scaleImages +"px");
          }
        break;
        case "lh":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterLHNoImage);
            setWidth(492*scaleImages +"px");
            setHeight(318*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterLHNoImage);  
            setWidth(402*scaleImages +"px");
            setHeight(318*scaleImages +"px");
          }
        break;

        case "m":
          if(tagMode=="room"){
            setXtadiumPosterNoImage(XtadiumRoomPosterMNoImage);
            setWidth(318*scaleImages +"px");
            setHeight(318*scaleImages +"px");
          }else{
            setXtadiumPosterNoImage(XtadiumContentPosterMNoImage);  
            setWidth(318*scaleImages +"px");
            setHeight(228*scaleImages +"px");
          }
        break;
        case "sv":
          setXtadiumPosterNoImage(XtadiumRoomPosterSVNoImage);
          setWidth(145*scaleImages +"px");
          setHeight(318*scaleImages +"px");
        break;
        case "sh":
          setXtadiumPosterNoImage(XtadiumRoomPosterSHNoImage);
          setWidth(318*scaleImages +"px");
          setHeight(145*scaleImages +"px");
        break;
        case "xs": 
          setXtadiumPosterNoImage(XtadiumRoomPosterXSNoImage);
          setWidth(145*scaleImages +"px");
          setHeight(145*scaleImages +"px");
        break;
      }
    }
    if(images && images[size]!=null){
      setDisplayImage(images[size]);
    }
    
  }, [size,tags,images,purchase,subscription,georestricted]);
  return (
    <>
      <div className="formTagsPreview-container" style={{ width:width,height:height }}>
        <div className="formTagsPreview-top-row--poster">
          <div style={{"margin":"auto","width":"90%","display":"flex","gap":"5px"}}>{topTags}</div>
        </div>
        {!displayImage && <img className="formTagsPreview-image" style={{"width":width,"height":height}} src={XtadiumPosterNoImage}  alt="Your Image" />}
        {displayImage && <img className="formTagsPreview-image" style={{"width":width,"height":height}} src={displayImage}  alt="Your Image" />}
        {tagMode=="content" && middleTags.length>0 && <div className="formTagsPreview-middle-row">{middleTags}</div>}
        {tagMode=="content" && <div className="formTagsPreview-description">
          <div>{name?name:"content name"}</div>
          <div className="formTagsPreview-bottom-row formTagsPreview-bottom-row--poster" style={{display: 'flex',alignItems: 'center',width: '100%',height: '70%',gap: '20px'}}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>{bottomLeftTags}</div>
            <div style={{ display: 'flex', gap: '5px', alignItems: 'center'}}>{bottomTags}</div>
          </div>
        </div>}
      </div>
    </>
  );
};

PosterPreview.propTypes = {
  size: PropTypes.string,
};

PosterPreview.defaultProps = {
  size: 'xxl',
};

export default PosterPreview;
